import DoAPICall from './DoAPICall'

//Create Client Mno
    export async function createClientMno(userToken, clientsmno){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'clientmnos',
            payLoad:{
                client_id:clientsmno.client_id,
                mno_id:clientsmno.mno_id,
                smsCharge:clientsmno.smsCharge,
                smsChannel:clientsmno.smsChannel
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All Client mno
    export async function getClientMnos(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientsmnos',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Client mno
    export async function getClientMno(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientmnos/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get mnos of client
    export async function getMnosOfClient(userToken,client_id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'mnosofclient/'+client_id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update Client mno
    export async function updateClientMno(userToken, clientsmno){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'clientmnos/'+clientsmno.id,
            payLoad:{
                smsCharge:clientsmno.smsCharge,
                smsChannel:clientsmno.smsChannel
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete Client Mno
    export async function deleteClientMno(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'clientmnos/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }
